import React, { useMemo, useState } from 'react';
import { EmptyTip } from 'tea-component';
import TrendsItem from '../TrendsItem';
import moment from 'moment';
import { groupByListData } from '../../utils';
import CardSlot from '@/pages/opinion/components/CardSlot';
import './index.scss';
import { useIntl } from 'umi';
import { scrollToAnchorPoint } from '@/pages/opinion/utils';
import LoadingCommon from '@op/components/LoadingCommon';
import { NO_DATE } from '@/pages/opinion/constants';

/**
 * 热点列表数据
 * @param platform              平台： 谷歌，推特
 * @param trendsList            热点数据列表
 * @param language              语言
 * @param loading               是否为加载数据状态，这个加载数据是列表底部加载数据
 * @param resetLoading          去掉所有列表，然后显示的加载状态
 * @param canUpdate             是否可以进行修改，这个是热点注释的编辑权限
 * @param setCitationReset      设置了热点注解后，进行的重置
 * @param isLoadingCompleted    数据是否加载完了
 * @returns
 */
export default function TrendsList({
  platform,
  trendsList,
  language,
  loading,
  resetLoading,
  canUpdate,
  setCitationReset,
  isLoadingCompleted,
}: {
  platform: string;
  trendsList: Array<any>;
  language: Array<string>;
  loading: boolean;
  isLoadingCompleted: boolean;
  resetLoading: boolean;
  canUpdate: boolean;
  setCitationReset: () => void;
}) {
  const [editId, setEditId] = useState<string>('-1');
  const { formatMessage } = useIntl();
  const trendsListElement = useMemo(() => {
    const obj: any = groupByListData(trendsList, formatMessage);
    const elements: Array<JSX.Element> = [];
    const keys = Object.keys(obj);
    keys.sort((one, two) => (moment(one).isBefore(two) ? 1 : -1));
    keys.forEach((key) => {
      const { list, time } = obj[key];
      list.sort((one: { rank: number }, two: { rank: number }) => {
        return one.rank - two.rank;
      });
      elements.push(
        <div className="dbo-trendsbox" key={time}>
          <div className="dbo-trendsbox-title">
            <span>{time}</span>
          </div>
          {list.map((item: any) => {
            return (
              <TrendsItem
                key={item.id}
                data={item}
                beginEditNote={() => {
                  setEditId(item.id);
                  scrollToAnchorPoint(item.id);
                }}
                canUpdate={canUpdate}
                closeEditNote={() => setEditId('-1')}
                reload={setCitationReset}
                editable={editId === item.id}
                trendsType={platform}
                language={language}
              />
            );
          })}
        </div>,
      );
    });
    return elements;
  }, [editId, platform, trendsList, language, canUpdate, setCitationReset]);

  return (
    <div className="trends-list-wrapper">
      {!resetLoading && trendsListElement}
      {loading ? (
        <CardSlot style={{ height: '100px' }}>
          <LoadingCommon status={'loading'} />
        </CardSlot>
      ) : trendsList.length === 0 ? (
        <EmptyTip
          className="dbo-state-tip"
          emptyText={formatMessage({
            id: NO_DATE.SELECTION,
          })}
        />
      ) : isLoadingCompleted ? (
        <EmptyTip
          className="tips dbo-state-tip"
          emptyText={formatMessage({
            id: 'No data to load',
          })}
        />
      ) : null}
    </div>
  );
}
